import * as React from 'react';

import { ListMonthsProps } from '../../components/list/months';
import ListMonth from '../../components/list/month';

import LoadMore from '../../components/month-selection/load-more';

const ListMonthsView: React.StatelessComponent<ListMonthsProps> = props => {
    return (
        <section className="ace-cal-list">
            <ul className="ace-cal-list-months stack-xl stack-border">
                {
                    props.monthsData.map(monthData => <ListMonth key={`${monthData.monthMoment.month()}${monthData.monthMoment.year()}`} monthData={monthData} />)
                }
            </ul>
            <LoadMore />
        </section>
    )
}

export default ListMonthsView;